import { AuthorizationSuccessResponse } from '@tassat/common-definitions';

import authService from 'Lib/auth/AuthService';
import history from 'Lib/browserHistory';

import authServiceMap from './auth/authServiceMap';
import { ApplicationMuiTheme } from './themes/muiTheme';

export const handleAuthentication = async (nextState, forAdmin, muiTheme: ApplicationMuiTheme) => {
    const loginMethod: string = muiTheme?.app?.clientTheme.features.Authentication.LoginMethod;
    let match;
    const pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
            return decodeURIComponent(s.replace(pl, ' '));
        },
        query = nextState.location.search.substring(1);

    const urlParams = {};
    while ((match = search.exec(query))) {
        urlParams[decode(match[1])] = decode(match[2]);
    }

    if (urlParams['error'] == 'unauthorized' && urlParams['error_description'] == 'user is blocked') {
        // handle the Locked User scenario
        history.push('/locked');
    } else if (urlParams['error']) {
        // catch all errors - logout
        console.error('Authorization Error: ', urlParams['error'], urlParams['error_description']);
        authService.logout(forAdmin);
    } else {
        // user is authorized - now lets get them a refresh token
        const authService = await authServiceMap[loginMethod]();
        if (authService) {
            await authService.handleAuthentication(forAdmin, urlParams as AuthorizationSuccessResponse);
        } else {
            console.error(`AuthService not found for login method: ${loginMethod}`);
        }
    }
};

export const handleCodeAuthentication = (nextState) => {
    if (/access_token|id_token|error/.test(nextState.location.hash)) {
        authService.handleCodeAuthentication();
    }
};